import Comment from './comment';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import React, {Component} from 'react';

import UserIsTyping from './user-is-typing';

export const hasNewComment = (newComments = [], oldComments = []) => {
    if (!Array.isArray(newComments) || !Array.isArray(oldComments)) {
        return false;
    }
    return newComments.length !== oldComments.length;
};

export const isMyComment = (newComment) => {
    return !!(newComment && newComment.isMine);
};

export class CommentsList extends Component {
    static defaultProps = {
        comments: null,
        pollInterval: 1000,
        startPolling: () => {},
        stopPolling: () => {}
    }

    constructor(props) {
        super(props);
        this.timeout = null;
        this.state = {
            isReceivingUserComment: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const {comments} = this.props;
        const newComments = nextProps.comments;

        if (!hasNewComment(newComments, comments)) {
            return;
        }

        if (!isMyComment(newComments[0])) {
            this.userIsTyping();
        }
    }

    /* istanbul ignore next */
    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    // make it look like another user is typing
    userIsTyping = () => {
        const {pollInterval, startPolling, stopPolling} = this.props;

        stopPolling();
        this.setState({isReceivingUserComment: true});

        /* istanbul ignore next */
        this.timeout = setTimeout(() => {
            startPolling();
            this.setState({isReceivingUserComment: false});
        }, pollInterval + 500);
    }

    render() {
        const {comments, loading} = this.props;
        const {isReceivingUserComment} = this.state;
        return (
            <div className={`comments-modal__comments__list ${loading ? 'is-loading' : ''}`}>
                <LoadingOverlay loading={loading} />
                {isReceivingUserComment && <UserIsTyping />}
                {comments && comments.map((props, idx) => {
                    if (isReceivingUserComment && idx === 0) {
                        return null;
                    }
                    const {author, uuid, localeCreateTime, ...rest} = props;
                    return <Comment user={author} timestamp={localeCreateTime} {...rest} key={uuid}/>;
                })}
            </div>
        );
    }
}

export default CommentsList;



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/components/comments-list.js